const portfolioData = [
    {
        title: 'Moodify',
        shortDesc: 'Machine Learning music mood classifier',
        points: [
            "Deployed with Nginx & Gunicorn on AWS EC2",
        ],
        imageFileName: 'moodify.png',
        projectLink: 'https://moodify.austinshih.com',
    },
    {
        title: 'TortlePoll - Live polling website',
        shortDesc: 'Filter results by demographic group, track your polls, take public polls or keep polls private',
        points: [
            "Dynamic data visualization using Chart.js and Pusher for live updating",
        ],
        imageFileName: 'TortlePoll.PNG',
        projectLink: 'https://tortlepoll.austinshih.com',
    }
]

export default portfolioData